<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "TagManager",
};
</script>
